import axios from '@/api/config'

export const getTemplateHtml = (cruiseId, template) => {
  return axios.get(`/contract/${cruiseId}/draft`, { params: { template } })
}

export const getTemplatePdf = (cruiseId, template) => {
  return axios.get(`/contract/${cruiseId}/pdf`, { params: { template }, responseType: 'arraybuffer' })
}
